export default __webpack_public_path__ + "/dist/images/logo3.386f34896ea53862645633a7dd666b50.png";